import { Box } from "@mui/material";
import type { FC } from "react";
import { getAuthBackgroundStyle } from "../../config/background.ts";

/** Full-bleed blurred layer; lives inside a positioned shell (fixed or relative). */
export const AuthBlurredBackground: FC<{ isDark: boolean }> = ({ isDark }) => (
    <Box
        aria-hidden
        sx={{
            position: "absolute",
            inset: 0,
            background: getAuthBackgroundStyle(isDark),
            filter: "blur(8px)",
            transform: "scale(1.1)",
            zIndex: 0
        }}
    />
);
